<div class="row">
  <div class="col-12">
    @if (calculationResponse?.status === 'CREATED' && calculationResponse?.resultId !== undefined) {
      <div
        class="alert alert-warning"
        role="alert">
        <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Attention! Les résultats pourraient ne
      plus être à jour. </h2>
      Puisque des modifications ont été apportése aux valeurs du formulaire, il se pourrait que les résultats ne
      soient pas à jour.
      Pour vous assurez que les résultats soient bien à jour avec les nouvelles valeurs, veuillez rouler le calcul
      de nouveau.
      <br>
        <br>
          <div>
            <a href="" routerLink="../" style="margin-right: 15px;">Retour au formulaire</a>
          </div>
        </div>
      }
      @if (calculationResponse?.status === 'CREATED'  && calculationResponse?.resultId === undefined) {
        <div
          class="alert alert-warning"
          role="alert">
          <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Résultats indisponibles</h2>
          Afin de voir les résulats, vous devez rouler le calcul au moins une fois.
          <br>
            <br>
              <div>
                <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
                formulaire</a>
              </div>
            </div>
          }

          @if (calculationResponse?.status === 'ERROR') {
            <div class="alert alert-danger" role="alert">
              <h2 class="alert-heading"><i class="fas fa-exclamation-circle"></i> Certaines erreurs se sont produites.
            Vous pouvez les corriger en retournant au formulaire. </h2>
            <ul>
              @for (error of calculationResponse.results?.errors; track error) {
                <li
                  style="font-size:14pt;">{{ getErrorText(error) }}
                </li>
              }
            </ul>
            <div class="mt-5">
              <a class="btn btn-sm btn-secondary" href="" routerLink="../">Retourner au formulaire</a>
            </div>
          </div>
        }

        @if (calculationResponse?.status === 'COMPLETED' && calculationResponse.results?.warnings.length > 0) {
          <div
            class="alert alert-warning"
            role="alert">
            <h2 class="alert-heading"><i class="fas fa-exclamation-circle me-3"></i> Votre calcul s'est complété avec
          quelques avertissements </h2>
          <ul>
            @for (warning of calculationResponse.results?.warnings; track warning) {
              <li
                style="font-size:14pt;">{{ warning }}
              </li>
            }
          </ul>
          <div class="mt-5">
            <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
            formulaire</a>
          </div>
        </div>
      }

      @if (calculationResponse?.status === 'IN_PROGRESS') {
        <div class="alert alert-primary">
          <h2 class="alert-heading mt-2 mb-2"><i class="fas fa-circle-notch fa-spin me-3"></i> Calcul en cours
        d'exécution.</h2>
      </div>
    }
  </div>
</div>

@if (calculationResponse?.results !== undefined && calculationResponse?.status === 'COMPLETED') {
  <div class="results">
    <div class="row">
      <h2 (click)="collapseResponse.toggle()"
        [attr.aria-expanded]="!isSectionResponsesCollapsed"
        aria-controls="responses">
        Responses
      </h2>
      <div #collapseResponse="ngbCollapse" [(ngbCollapse)]="isSectionResponsesCollapsed">
        <div class="card table-result-card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'"
                    [text]="'EGPS'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">
                    employeesGrossPensionableSalary
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ options.employeesGrossPensionableSalary | currencyCents }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'EQPPCW'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">
                    employeesQPPContributionsWithheld
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ options.employeesQPPContributionsWithheld | currencyCents }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'NPPY'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">numberOfPayPeriodsInTheYear
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ options.numberOfPayPeriodsInTheYear }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'Y'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">year
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ options.year }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <h2 (click)="collapseResults.toggle()"
        [attr.aria-expanded]="!isSectionResultsCollapsed"
        aria-controls="results">
        Results
      </h2>
      <div #collapseResults="ngbCollapse" [(ngbCollapse)]="isSectionResultsCollapsed">
        <div class="card table-result-card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'"
                    [text]="'MC'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">maximumContribution
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ results.maximumContribution | currencyCents }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'EAPP'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">
                    exemptionAccordingToPayPeriods
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ results.exemptionAccordingToPayPeriods | currencyCents }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'EC'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">employerContribution
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ results.employerContribution | currencyCents }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'EEC'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">employeeContribution
                  </div>
                  <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                  <div class="table-result-col table-result-col-value">{{ results.employeeContribution | currencyCents }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
